module.exports = __webpack_public_path__ + "03_short_yellow.050bd8aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/03_short_yellow.png
// module id = wtdR
// module chunks = 0